import {
  writeIssueEvent,
  type IssueComment,
  type IssueCommentEventResponse,
} from "./collaboration";

export type { IssueComment };

/** Shared by Issues UI and Think (`add_issue_comment` → same POST). */
export async function addIssueComment(
  org: string,
  project: string,
  issueId: string,
  body: string,
  idempotencyKey: string = crypto.randomUUID(),
): Promise<IssueComment> {
  const trimmed = body.trim();
  if (!trimmed) throw new Error("comment body required");
  const res: IssueCommentEventResponse = await writeIssueEvent(org, project, issueId, {
    type: "comment",
    body: trimmed,
    idempotency_key: idempotencyKey,
  });
  const comment = res.comment;
  const commentId = res.comment_id ?? comment?.id;
  if (!commentId || !comment?.body) {
    throw new Error("comment saved response missing comment id");
  }
  return comment;
}
